import type { DealCaptureDealOption, DealFlow } from "@/types/deal-capture";

import { flowOf } from "./paths";

/**
 * The deal flow the Deals area is showing. An open deal decides it: a deal
 * reached from Recent activity or a bookmark carries no `?flow`, and the
 * toggle must still say which flow that deal belongs to. Otherwise the url's
 * `?flow` does, Integrated by default.
 */
export function flowInScope(search: string, openDeal?: DealCaptureDealOption): DealFlow {
  return openDeal?.flow ?? flowOf(search);
}

/** The deals in one flow — what the Deal picker and the deal counts list. */
export function dealsInFlow<T extends { flow: DealFlow }>(deals: readonly T[], flow: DealFlow): T[] {
  return deals.filter((d) => d.flow === flow);
}
